import { render, staticRenderFns } from "./ClassroomDialog.vue?vue&type=template&id=2193b852&scoped=true"
import script from "./ClassroomDialog.vue?vue&type=script&lang=js"
export * from "./ClassroomDialog.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDialog.vue?vue&type=style&index=0&id=2193b852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2193b852",
  null
  
)

export default component.exports